import React, { useContext, useEffect, useState } from "react";
import COINPARLIAMENT from "assets/images/COINPARLIAMENT.webp";
import SPORTPARLIAMENT from "assets/images/SPORTPARLIAMENT.webp";
import STOCKPARLIAMENT from "assets/images/STOCKPARLIAMENT.webp";
import VOTINGPARLIAMENT from "assets/images/VOTINGPARLIAMENT.webp";
import styled from "styled-components";
import { Buttons } from "Components/Atoms/Button/Button";
import UserContext from "Contexts/User";
import axios from "axios";
import { auth } from "../firebase";
import AppContext from "../Contexts/AppContext";
import ShareBlue from "../assets/svg/ShareBlue.svg";
import ShareGold from "../assets/svg/ShareGold.svg";
import { ToastType } from "Contexts/Notification";
import { showToast } from "App";
import copy from "copy-to-clipboard";
import whatsApp from "../assets/images/whatsapp.svg"
import facebook from "../assets/images/facebook.svg"
import XTwitter from "../assets/images/x-twitter.svg"
import './styles.css';
import { Link, useNavigate } from 'react-router-dom';
import TelegramLogo from "../assets/svg/Telegram.svg"
import styles from "../Pages/FrontPage/FrontPage.module.css";

import VotingParliamentImg from '../assets/images/VotingParliament.jpg';
import CoinParliamentImg from '../assets/images/CoinParliament.jpg';
import PokerParliamentImg from '../assets/images/PokerParliament.jpg';
import messiandronaldoImg from '../assets/images/messiandronaldo.png';
import AnimeVoting from '../assets/images/AnimeVoting.jpg';
import STOCKPARLIAMENTAnimeVoting from '../assets/images/STOCKPARLIAMENT.jpg';
import FunParliament from '../assets/images/FunParliament.jpg';
import TheVote from '../assets/images/TheVote.jpg';
import BUYGET from '../assets/images/BUY&GET.jpg';
import HomeCard from "../Components/HomeCard/HomeCard";

import Img1 from '../assets/HomePageImage/NewIcons/Img1.png'
import Img2 from '../assets/HomePageImage/NewIcons/Img2.png'
import Img3 from '../assets/HomePageImage/NewIcons/Img3.png'
import Img4 from '../assets/HomePageImage/NewIcons/Img4.png'
import Img5 from '../assets/HomePageImage/NewIcons/Img5.png'
import Img6 from '../assets/HomePageImage/NewIcons/Img6.png'
import Img7 from '../assets/HomePageImage/NewIcons/Img7.png'
import Img8 from '../assets/HomePageImage/NewIcons/Img8.png'
import Img9 from '../assets/HomePageImage/NewIcons/Img9.png'
import Img10 from '../assets/HomePageImage/NewIcons/Img10.png'
import { isTelegramWebView } from "Components/LoginComponent/Login";
import { isPWAInstalled } from "../utils/pwaUtils";



// const Button = styled.a`
//   flex-direction: column;
//   justify-content: center;
//   border: 1px solid white;
//   border-radius: 5px;
//   background-color: #160133;
//   padding: 1em;
//   text-decoration: none;
//   color: white;
//   cursor: pointer;
//   text-align: center;
//   min-width: 9em;
//   &:hover {
//     background: white;
//     color: #160133;
//     box-shadow: rgb(67 47 229) 0px 4px 1px, rgb(170 164 220) 0px 8px 6px;
//   }
// `;


const AllimageBox = styled.div` 
 width:${window.screen.width > 767 ? "80%" : "98%"};
 
`;


const ButttonDiv = styled.div`

width: 130px;
height: 50px;
border: 3px solid white;
display: flex;
justify-content: center;
border-radius: 50px;
background: linear-gradient(
  180deg,
  rgba(82, 99, 184, 1) 0%,
  rgba(178, 102, 245, 1) 100%
  );
  animation: home-image 1s infinite;
  transition: background 1s;
  
  @keyframes home-image {
    0% {
      background: linear-gradient(
        180deg,
        rgba(82, 99, 184, 1) 0%,
        rgba(178, 102, 245, 1) 100%
        );
        color: #b869fc;
        }
        100% {
          background: linear-gradient(
            180deg,
            rgba(212, 176, 92, 1) 0%,
            rgba(243, 236, 60, 1) 100%
            );
            color: #daa636;
            }
            }
            
            button {
              
            background: white;
            border: 1px solid white;
            border-radius: 50px;
            padding: 0px;
            margin: 4px 0px;
            font-size: 14px !important;
            color: red;
            width: 118px;
            height:36px;
            color: #b869fc;
            font-family: "Lilita One";
            font-family: Rounded Mplus 1c;
            font-size: 15px;
            transition: color 1s;
            
            & img {
              width: 17px;
              margin-left: 10px;
              color: red;
              }
              
              animation: colorText 1s infinite ;
              
              @keyframes colorText {
                0% {
                  color: #b869fc;
                  }
                  100% {
                    color: #daa636;
                    //  color:#DAA636;
                    }
                    }
                    }
`;
export const Wrapper = styled.div`
  width:${window.screen.width > 767 ? "500px" : "98%"};
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;    
  padding: 10px;
`;

export const StyledButton = styled.button<{ $fullWidth?: boolean }>`
  padding:${window.screen.width > 767 ? " 12px 24px" : " 12px 15px"};
  background-color: ${({ $fullWidth }) => ($fullWidth ? '#d0ccff' : '#8e00f8')};
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  min-width: ${({ $fullWidth }) => ($fullWidth ? '300px' : 'auto')};
  text-align: center;

  &:hover {
    background-color:#d0ccff;
  }
`;

// const Sites = [
//   {
//     img: COINPARLIAMENT,
//     des: 'Coin Parliament is a web 3-based vote to earn game where you can make better investment decisions, mint NFTs, and earn rewards by voting and following top influencers.',
//     title: 'COIN PARLIAMENT',
//     redirect: 'https://coinparliamentstaging.firebaseapp.com/',
//     // redirect: 'http://localhost:3001/',
//     domain: process.env.REACT_APP_COIN_API,
//     name: 'coin',
//   },
//   {
//     img: SPORTPARLIAMENT,
//     des: 'Sport Parliament is an innovative web 3-based platform that allows sports fans to vote on their favorite teams and athletes while earning rewards and staying up-to-date on the latest news and trends.',
//     title: 'SPORT PARLIAMENT',
//     redirect: 'https://sportparliament.com/',
//     domain: process.env.REACT_APP_SPORT_API,
//     name: 'sport',
//   },
//   {
//     img: STOCKPARLIAMENT,
//     des: 'Stock Parliament is a revolutionary web 3-based platform that combines social voting and investing to help you make better investment decisions, earn rewards, and stay ahead of the curve in the fast-paced world of stocks.',
//     title: 'STOCK PARLIAMENT',
//     redirect: 'https://stockparliament.com/',
//     domain: process.env.REACT_APP_STOCK_API,
//     name: 'stock',
//   },
//   {
//     img: VOTINGPARLIAMENT,
//     des: 'The ultimate voting platform for a wide range of topics, including celebrities, music, politics, religion, world economy, and more. Express your opinions, make your voice heard, and earn rewards for your participation. ',
//     title: 'VOTING PARLIAMENT',
//     redirect: 'https://votingparliament.com/',
//     // redirect: 'http://localhost:3001/',
//     domain: process.env.REACT_APP_VOTING_API,
//     name: 'voting',
//   },
// ];
enum SiteTypes {
  coin = "coin",
  sport = "sport",
  stock = "stock",
  voting = "voting",
  fun = "fun",
  poker = "poker",
  anime = "anime",
}
function Home() {
  const [showShare, setShowShare] = useState<boolean | string>(false);
  const { setLogin } = useContext(AppContext);
  const { user } = useContext(UserContext);
  const isTelegram = isTelegramWebView();
  // @ts-ignore
  const initData = window.Telegram.WebApp.initData;
  const [sites, setSites] = useState<{ [key: string]: any }>({
    [SiteTypes.coin]: {
      img: COINPARLIAMENT,
      des: "Coin Parliament is a web 3-based vote to earn game where you can make better investment decisions, mint NFTs, and earn rewards by voting and following top influencers.",
      title: "COIN PARLIAMENT",
      redirect: "https://coinparliament.com/",
      // redirect: 'http://localhost:3001/',
      domain: process.env.REACT_APP_COIN_API,
      name: "coin",
      isLive: true
    },
    [SiteTypes.fun]: {
      redirect: "https://funparliament.com/",
      domain: process.env.REACT_APP_FUN_API,
      des: "Fun Parliament is an innovative web 3-based platform that allows fun fans to vote on their favorite teams and athletes while earning rewards and staying up-to-date on the latest news and trends.",
      title: "FUN PARLIAMENT",
      name: "fun",
      isLive: true
    },
    [SiteTypes.poker]: {
      redirect: "https://pokerparliament.com/",
      domain: process.env.REACT_APP_POKER_API,
      des: "Poker Parliament is an innovative web 3-based platform that allows poker fans to vote on their favorite teams and athletes while earning rewards and staying up-to-date on the latest news and trends.",
      title: "POKER PARLIAMENT",
      name: "poker",
      isLive: true
    },
    [SiteTypes.anime]: {
      redirect: "https://animevoting.com/",
      domain: process.env.REACT_APP_ANIME_API,
      des: "Anime Parliament is an innovative web 3-based platform that allows anime fans to vote on their favorite teams and athletes while earning rewards and staying up-to-date on the latest news and trends.",
      title: "ANIME PARLIAMENT",
      name: "anime",
      isLive: true
    },
    [SiteTypes.sport]: {
      img: SPORTPARLIAMENT,
      des: "Sport Parliament is an innovative web 3-based platform that allows sports fans to vote on their favorite teams and athletes while earning rewards and staying up-to-date on the latest news and trends.",
      title: "SPORT PARLIAMENT",
      redirect: "https://sportparliament.com/",
      domain: process.env.REACT_APP_SPORT_API,
      name: "sport",
      isLive: true
    },
    [SiteTypes.stock]: {
      img: STOCKPARLIAMENT,
      des: "Stock Parliament is a revolutionary web 3-based platform that combines social voting and investing to help you make better investment decisions, earn rewards, and stay ahead of the curve in the fast-paced world of stocks.",
      title: "STOCK PARLIAMENT",
      redirect: "https://stockparliament.com/",
      domain: process.env.REACT_APP_STOCK_API,
      name: "stock",
      isLive: true
    },
    [SiteTypes.voting]: {
      img: VOTINGPARLIAMENT,
      des: "The ultimate voting platform for a wide range of topics, including celebrities, music, politics, religion, world economy, and more. Express your opinions, make your voice heard, and earn rewards for your participation. ",
      title: "VOTING PARLIAMENT",
      redirect: "https://votingparliament.com/",
      // redirect: 'http://localhost:3001/',
      domain: process.env.REACT_APP_VOTING_API,
      name: "voting",
      isLive: true
    },
  });

  const [loading, setLoading] = useState("");
  // let userIds = JSON.parse(localStorage.getItem("userId") || "{}");  
  const [userIds, setUserIds] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("userId") || "{}");
    } catch (error) {
      console.error("Error parsing userId from localStorage:", error);
      return {};
    }
  });
  const [EmailId, setEmailId] = useState(() => JSON.parse(localStorage.getItem("EmailId") || ""));

  useEffect(() => {
    const handleStorageChange = (e: any) => {
      if (e.key === "userId") {
        try {
          setUserIds(JSON.parse(e.newValue || "{}"));
        } catch (error) {
          console.error("Error parsing userId from storage event:", error);
          setUserIds({});
        }
      }
      if (e.key === "EmailId") {
        setEmailId(JSON.parse(e.newValue || ""));
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const redirectUserToSite = (site: { [key: string]: string }) => {
    console.log(site.domain, userIds[site.name], EmailId, auth.currentUser?.email, "sitestokecn")
    setLoading(site.name);
    axios
      .post(`${site.domain}isLoggedInFromVoteToEarn`, {
        data: {
          userId: userIds[site.name],
          email: EmailId || auth.currentUser?.email,
        },
      })
      .then((response) => {

        // console.log(response,"responseisLoggedInFromVoteToEarn")
        if (response?.data?.result?.token) {
          setSites((prev) => {
            return {
              ...prev,
              [site.name]: {
                ...site,
                redirect: `${site.redirect}?token=${response?.data?.result?.token}`,
              },
            };
          });
          // Sites[index].redirect = `${redirectUrl}?token=${response?.data?.result?.token}`
          // window.location.replace(`${redirectUrl}?token=${response?.data?.result?.token}`);
        }
      })
      .catch((err) => {
        console.log(err)
      }).finally(() => {
        setLoading("");
      })
  };
  useEffect(() => {
    if (Object.keys(userIds).length < 1) return;
    redirectUserToSite(sites.coin);
    redirectUserToSite(sites.sport);
    redirectUserToSite(sites.stock);
    redirectUserToSite(sites.voting);
    redirectUserToSite(sites.anime);
    redirectUserToSite(sites.fun);
    redirectUserToSite(sites.poker);

  }, []);

  const pathname = window.location.pathname
  const navigate = useNavigate();
  // useEffect(()=>{
  //   if(pathname == "/"){
  //     navigate("/apps")
  //   }

  // },[pathname])

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const imageSources = [
    ShareGold,
    ShareBlue,
    // Add more image sources as needed
  ];
  // @ts-ignore
  const getAllId = (() => {
    try {
      return JSON.parse(localStorage.getItem("userId") || "{}");
    } catch (error) {
      console.error("Error parsing userId:", error);
      return {};
    }
  })();
  // @ts-ignore
  const getAllDisplayName = (() => {
    try {
      return JSON.parse(localStorage.getItem("DisplayName") || "{}");
    } catch (error) {
      console.error("Error parsing DisplayName:", error);
      return {};
    }
  })();

  const [shareIcon, setshareIcon] = useState({

    coin: {
      name: "/cplog.png",
      id: getAllId?.coin,
      displayName: getAllDisplayName?.coin,
      url: "coinparliament.com"
    },
    sport: {
      name: "/SPlogo.png",
      id: getAllId?.sport,
      displayName: getAllDisplayName?.sport,
      url: "sportparliament.com"
    },
    voting: {
      name: "/vplogo.png",
      id: getAllId?.voting,
      displayName: getAllDisplayName?.voting,
      url: "votingparliament.com"
    },
    stock: {
      name: "/sptlogo.png",
      id: getAllId?.stock,
      displayName: getAllDisplayName?.stock,
      url: "stockparliament.com"
    }

  })

  useEffect(() => {
    const interval = setInterval(() => {
      // Step 4: Update the image index, resetting to 0 if it reaches the end
      setCurrentImageIndex(
        (prevIndex) => (prevIndex + 1) % imageSources.length
      );
    }, 1000); // 1000ms = 1 second

    // Step 5: Clear the interval when the component unmounts
    return () => clearInterval(interval);
  }, [currentImageIndex]);

  const referralUrl = (value: any, url?: any, displayName?: any) => {
    const lastSixCharacters = value.slice(-6);
    // @ts-ignore
    const firstTwoCharacters = user?.email.slice(0, 2);

    const result = firstTwoCharacters + lastSixCharacters;

    if (url != "") {
      return `${document.location.protocol}//${url}/?refer=${result}`
    }
  };
  const shareText = `Hey,%0ajoin me on Coin Parliament and earn rewards for your opinion!%0aLet's vote together!`

  const HomeButtons = [
    { label: 'BUY & GET' },
    { label: 'Checkout BUY & GET' },
    { label: 'One Key' },
    { label: 'Apps', fullWidth: true },
  ];


  const cardData = [
    {
      buttonLabel: "Pick Your Side",
      backgroundImage: CoinParliamentImg,
      link: sites["coin"].redirect,
    },
    {
      // buttonLabel: "Let's Vote",
      buttonLabel: "Coming Soon",
      backgroundImage: VotingParliamentImg,
      // link:sites["voting"].redirect,
    },
    {
      buttonLabel: "",
      backgroundImage: PokerParliamentImg,
    },
    {
      // buttonLabel: "Game On",
      buttonLabel: "Coming Soon",
      backgroundImage: messiandronaldoImg,
      // link:sites["sport"].redirect,
    },
    {
      // buttonLabel: "BUY & GET",
      backgroundImage: BUYGET,
    },
    {
      // buttonLabel: "Pick Your Hero",
      buttonLabel: "Coming Soon",
      backgroundImage: AnimeVoting,
    },
    {
      // buttonLabel: "Vote the Market",
      buttonLabel: "Coming Soon",
      backgroundImage: STOCKPARLIAMENTAnimeVoting,
      // link:sites["stock"].redirect,
    },
    {
      // buttonLabel: "Join the Fun",
      buttonLabel: "Coming Soon",
      backgroundImage: FunParliament,
    },
    {
      // buttonLabel: "Vote with Impact",
      buttonLabel: "Coming Soon",
      backgroundImage: TheVote,
    },
    // Add more items as needed...
  ];


  const iconsForGrid = [
    { src: Img1, name: 'COIN PARLIAMENT', link: sites["coin"].redirect, route: '/coinparliament' },
    { src: Img2, name: 'VOTING PARLIAMENT', link: sites["voting"].redirect, route: '/votingparliament' },
    { src: Img3, name: 'STOCK PARLIAMENT', link: sites["stock"].redirect, route: '/stockparliament' },
    { src: Img6, name: 'THE VOTE', link: "", route: '' },
    { src: Img10, name: 'V2E', link: window.location.href, route: '' }, // Center button
    { src: Img7, name: 'ANIME VOTING', link: sites["anime"].redirect, route: '/aminvoting' },
    { src: Img5, name: 'POKER PARLIAMENT', link: sites["poker"].redirect, route: '/pokerparliament' },
    { src: Img4, name: 'FUN PARLIAMENT', link: sites["fun"].redirect, route: '/funparliament' },
    { src: Img8, name: 'SPORT PARLIAMENT', link: sites["sport"].redirect, route: '/sportparliament' },
  ];

  return (
    <div className="d-flex flex-column justify-content-center align-items-center"
      style={{
        marginTop: window.innerWidth < 768 ? "20px" : "30px",
        width: "100%"
      }}
    >
      {/* <AllimageBox className="d-flex justify-content-around align-items-center flex-wrap">
        {cardData?.map((card, index) => (
          <HomeCard
            key={index}
            index={index}
            link={card?.link || ""}
            buttonLabel={card.buttonLabel}
            backgroundImage={card.backgroundImage}
          />
        ))}
      </AllimageBox> */}


      <div className={styles.newIconsGridContainer}
        style={{ width: "100%", }}
      >
        <div className={styles.newIconsGrid}>
          {iconsForGrid.map((item, idx) => {
            const isDisabled = !item.link || item.link === "";

            return (
              <div key={idx} className={styles.newIconCard}>
                <div
                  className={`${styles.newIconImageWrapper} ${isDisabled ? styles.disabled : ''}`}
                  onClick={() => {
                    if (item.name == "V2E") {
                      navigate("/profile/walletDetails")
                      return
                    } else if (isDisabled) {
                      // Do nothing if disabled
                      return;
                    } else {
                      // Get the parliament name key for token lookup
                      const parliamentKey = item.name.toLowerCase().replace(' parliament', '').replace(' voting', '');
                      const tokenUrl = sites[parliamentKey]?.redirect || item.link;

                      // Prepare final URL with Telegram data if needed
                      let finalUrl = isTelegram
                        ? `${tokenUrl}${tokenUrl.includes('?') ? '&' : '?'}inituserData=${encodeURIComponent(initData)}`
                        : tokenUrl;

                      // Check if running as PWA
                      const runningAsPWA = isPWAInstalled();

                      if (runningAsPWA) {
                        // PWA Mode: Use iframe route to maintain single-app feel
                        // URL stays as app.vototoearn.net/stockparliament
                        if (item.route) {
                          navigate(`${item.route}?url=${encodeURIComponent(finalUrl)}`);
                        } else {
                          // Fallback to opening in new tab if no route
                          window.open(finalUrl, "_blank");
                        }
                      } else {
                        // Browser Mode: Direct navigation to parliament URL
                        // Opens parliament in same tab with its own URL
                        window.location.href = finalUrl;
                      }
                    }
                  }}
                  style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                >
                  <img src={item.src!} alt={item.name} className={styles.newIconImage} />
                </div>
                <span className={styles.newIconName}>
                  {item.name.includes('PARLIAMENT') ? (
                    <>
                      {item.name.replace(' PARLIAMENT', '')}
                      <br />
                      PARLIAMENT
                    </>
                  ) : (
                    item.name
                  )}
                </span>
              </div>
            );
          })}
        </div>
      </div>



      {/* <div className="pb-3" style={{textAlign:"center"}}>
        <h3 style={{whiteSpace:"nowrap"}}>         
         JOIN FOR UPDATES
         &nbsp;
         <button className="buttonHover" style={{borderRadius:"15px",padding:"3px"}}>
           <Link to="https://telegram.me/VoteToEarn" target="_blank"> 
           <img src={TelegramLogo} alt="Telegram Logo" style={{width:"30px", paddingBottom:"2px"}} /> 
           </Link> 
         </button>
        </h3>   
      </div> */}

      {/* <h1 className="pb-2">TOP V2E APPS</h1> */}
      {/* <div className="row">
        {Object.keys(sites).map((key: string, index) => {          
          return (
            <div
              key={index}
              className="card mb-3 col-sm-6"
              style={{
                background: "#160133",
                color: "white",
                textAlign: "justify",
              }}
            >
              <div className="row no-gutters">
                <div className="col-lg-6 p-0">
                  <img
                    src={sites[key].img}
                    className="card-img pt-3"
                    alt="img"
                    style={{ height: "92%" }}
                  />
                </div>
                <div className="col-lg-6 p-0 d-flex">
                  <div className="card-body d-flex flex-column justify-content-center">
                    <h6 style={{ marginRight: "1em", textAlign: "center" }}>
                      {sites[key].title}
                    </h6>
                    <p className="card-text" style={{ marginTop: "5px" }}>  
                      {sites[key].des}
                    </p>

                    <div
                      className="d-flex mt-2 align-items-center"
                      style={{ gap: "4px" }}
                    >
                    {sites[key].isLive ?
                      <>
                       <ButttonDiv className="mt-1 m-auto">
                        <button>
                         <a
                            href={sites[key].redirect}
                            target="_blank"
                            style={{ textDecoration: "none" }}
                          >
                           {loading === sites[key]?.name ? (
                              <span className="loading">wait...</span>
                            ) : (
                              "VOTE NOW !"
                          )}
                         </a>
                        </button>
                       </ButttonDiv>

                       <ButttonDiv className="mt-1 m-auto">
                        <button
                          onClick={() => {
                            if (!user?.uid) {
                              setLogin(true);
                              return;
                            } else {
                              setShowShare((prev) => !prev ?sites[key]?.name : false );
                            }
                          }}
                          
                        >
                          EARN NOW !
                          <img
                            src={imageSources[currentImageIndex]}
                            alt=""
                            width={"20px"}
                            className=""
                          />
                        </button>
                       </ButttonDiv>
                     </> :
                      <ButttonDiv className="mt-1 m-auto">
                        <button
                       
                          >
                            <span style={{ textDecoration: "none" , color:"#0d6efd"}}>COMING SOON...</span>
                              
                        </button>
                      </ButttonDiv>
                    } 

                      {showShare == sites[key]?.name  && <div className={"HomeshareBox"} style={window.screen.width < 300 ? {
                        marginLeft: '2em',
                        top: '26.5em',                        
                        zIndex : 1000,
                      } : (window.screen.width <= 425 ? {
                        marginLeft: '8em',
                          top: '26.5em',
                          zIndex: 1000,
                      } : {
                        marginLeft: '10em',
                            top: '14.5em',                        
                            zIndex: 1000,
                      })}>
                        <div className="d-flex flex-column pt-3">                          
                          <div className="d-flex py-2" key={index}>                                                        
                              <span className="material-symbols-outlined text-secondary me-2"
                              onClick={() => {
                                
                                copy(referralUrl(shareIcon[`${key}`].id, shareIcon[`${key}`].url, shareIcon[`${key}`].displayName));
                                  showToast(
                                    'Your referral link is copied to the clipboard.',
                                    ToastType.SUCCESS
                                  );
                                }}>
                                content_copy
                            </span>
                            
                            <a href={`https://api.whatsapp.com/send/?phone&text=${`${shareText} ${referralUrl(shareIcon[`${key}`].id, shareIcon[`${key}`].url, shareIcon[`${key}`].displayName)}`.replace(" ", "+")}&app_absent=0`} target="_blank" onClick={() => setShowShare(false)}>
                                <img src={whatsApp} className="me-2" />
                            </a>                            
                            <a href={`https://twitter.com/intent/tweet?url=${referralUrl(shareIcon[`${key}`].id, shareIcon[`${key}`].url, shareIcon[`${key}`].displayName)}?check_suite_focus=true&text=${shareText}`} target="_blank" onClick={() => setShowShare(false)}>
                                <img src={XTwitter} width={'25px'} height={'25px'} className="me-2" />
                            </a>                            
                            <a href={`https://www.facebook.com/sharer/sharer.php?u=${referralUrl(shareIcon[`${key}`].id, shareIcon[`${key}`].url, shareIcon[`${key}`].displayName)}&t=${shareText}`} target="_blank" onClick={() => setShowShare(false)}>
                                <img src={facebook} className="me-2" />
                              </a>
                            </div>                          
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div> */}
    </div>
  );
}

export default Home;
